var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 411.1 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-7);\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 1px;\r\n      }\r\n\r\n      .cls-6, .cls-7 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: gray;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-8);\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8,
    y1: 146.2,
    x2: 159.9,
    y2: 146.2,
    gradientTransform: "translate(0 170) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67349d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e062b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.1,
    y1: 103.9,
    x2: 168.9,
    y2: 103.9,
    gradientTransform: "translate(0 170) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67349d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e062b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 78.6,
    x2: 169,
    y2: 78.6,
    gradientTransform: "translate(0 170) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67349d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e062b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2.1,
    y1: 55.7,
    x2: 166.9,
    y2: 55.7,
    gradientTransform: "translate(0 170) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67349d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e062b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 10.5,
    y1: 34.3,
    x2: 158.5,
    y2: 34.3,
    gradientTransform: "translate(0 170) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67349d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e062b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 31.5,
    y1: 10.4,
    x2: 137.6,
    y2: 10.4,
    gradientTransform: "translate(0 170) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67349d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e062b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 84.9,
    y1: 62.9,
    x2: 84.9,
    y2: 83.4,
    gradientTransform: "translate(0 170) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67349d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e062b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 60.8,
    y1: 117.8,
    x2: 109.1,
    y2: 117.8,
    gradientTransform: "translate(0 170) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67349d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e062b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 67.6,
    y1: 122.6,
    x2: 102.6,
    y2: 122.6,
    gradientTransform: "translate(0 170) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67349d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e062b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M160.5,47.5H8.5C22.2,19.4,51.1,0,84.5,0s62.3,19.4,76,47.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M31.5,150.3h106.1c-14.5,11.7-32.9,18.7-53.1,18.7s-38.5-7-53-18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M169,84.5c0,6.4-.7,12.7-2.1,18.8-1.8,7.8-4.6,15.2-8.4,22.1-4.2,7.7-9.7,14.6-16,20.6H26.5c-6.3-6-11.8-12.9-16-20.6-3.8-6.8-6.7-14.2-8.4-22.1C.7,97.2,0,90.9,0,84.5s0-2.8.1-4.2c0-.3,0-.5,0-.8.6-9.8,2.8-19.1,6.4-27.8h155.9c3.6,8.6,5.9,18,6.4,27.8,0,.3,0,.5,0,.8,0,1.4.1,2.8.1,4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M159.9,47.5H8C21.7,19.4,50.5,0,83.9,0s62.3,19.4,76,47.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.9,80.3H.1c0-.3,0-.5,0-.8.6-9.8,2.8-19.1,6.4-27.8h155.9c3.6,8.6,5.9,18,6.4,27.8,0,.3,0,.5,0,.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169,84.5c0,6.4-.7,12.7-2.1,18.8H2.1c-1.4-6-2.1-12.3-2.1-18.8s0-2.8.1-4.2c0-.3,0-.5,0-.8h168.7c0,.3,0,.5,0,.8,0,1.4.1,2.8.1,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.9,103.3c-1.8,7.8-4.6,15.2-8.4,22.1H10.5c-3.8-6.8-6.7-14.2-8.4-22.1h164.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M158.5,125.4c-4.2,7.7-9.7,14.6-16,20.6H26.5c-6.3-6-11.8-12.9-16-20.6,0,0,147.9,0,147.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M137.6,150.3c-14.5,11.7-32.9,18.7-53.1,18.7s-38.5-7-53-18.7h106.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.9,107l-3-7.2h-19.7l-3,7.2h-10l17.9-40h10l17.8,40h-10.1,0ZM110.1,75.9l-6.6,15.8h13l-6.5-15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.8,67h9.4v31.6h20.1v8.5h-29.5v-40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.3,113.1v3.7h-5.5v14.4h-4.2v-14.4h-5.5v-3.7h15.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.4,125.3h-2.5v6h-4.3v-18.2h8.8c1.3,0,2.5.2,3.5.8,1,.5,1.8,1.2,2.3,2.2.5.9.8,2,.8,3.2s-.4,2.6-1.1,3.6-1.7,1.7-3,2.1l5.1,6.4h-5.1l-4.6-6h0ZM49.1,117.4c-.5-.4-1.2-.7-2.1-.7h-4.1v5.1h4.1c.9,0,1.6-.2,2.1-.7s.7-1.1.7-1.9-.2-1.4-.7-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.5,131.3l-1.3-3.3h-9l-1.3,3.3h-4.5l8.1-18.2h4.5l8.1,18.2h-4.6ZM65.7,117.2l-3,7.2h5.9l-2.9-7.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.8,130.5c-1.5-.8-2.6-1.9-3.4-3.3s-1.2-3.1-1.2-5,.4-3.5,1.2-5c.8-1.4,2-2.6,3.4-3.3s3.2-1.2,5-1.2c2.7,0,5,.9,6.9,2.8l-2.6,2.6c-1.2-1.1-2.6-1.7-4.2-1.7s-2.1.2-2.9.7c-.8.5-1.5,1.2-1.9,2-.5.9-.7,1.9-.7,3s.2,2.1.7,3,1.1,1.5,1.9,2c.8.5,1.8.7,2.9.7s1.7-.2,2.5-.5,1.5-.8,2.1-1.3l2.5,2.8c-2,1.9-4.3,2.8-7.1,2.8s-3.7-.4-5.2-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.7,131.3h-5.5l-6.4-7.2v7.2h-4.2v-18.2h4.2v7.1l6-7.1h5.2l-7.7,8.9,8.4,9.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.4,127.7h10v3.6h-14.1v-18.2h13.9v3.6h-9.7v3.7h9.2v3.4h-9.2v3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.3,125.3h-2.5v6h-4.3v-18.2h8.9c1.3,0,2.5.2,3.4.8,1,.5,1.8,1.2,2.3,2.2.5.9.8,2,.8,3.2s-.4,2.6-1.1,3.6-1.7,1.7-3.1,2.1l5.1,6.4h-5.1l-4.6-6h0ZM141,117.4c-.5-.4-1.2-.7-2.1-.7h-4.1v5.1h4.1c.9,0,1.6-.2,2.1-.7.5-.4.7-1.1.7-1.9s-.2-1.4-.7-1.9h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 84.9,
    cy: 96.9,
    r: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.9,22.9c-13.3,0-24.2,10.8-24.2,24.2s2.7,12.6,6.9,16.9l16.6,17.1c.3.3.9.3,1.2,0l16.6-17.1c2.2-2.2,3.9-4.8,5.1-7.6,1.2-2.9,1.9-6,1.9-9.3,0-13.4-10.8-24.2-24.2-24.2ZM84.9,65.1c-9.9,0-18-8.1-18-18s8.1-18,18-18,18,8.1,18,18-8.1,18-18,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.1,5.9h5.7v19.1h12.2v5.1h-17.9V5.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.4,13v17.1h-4.7l-.4-2c-1.5,1.6-3.4,2.4-5.7,2.4s-3-.4-4.2-1.1-2.2-1.8-2.9-3.2c-.7-1.4-1-2.9-1-4.6s.4-3.3,1-4.6c.7-1.4,1.7-2.4,2.9-3.2s2.6-1.1,4.2-1.1,2.2.2,3.2.6c1,.4,1.8,1,2.5,1.8l.4-2h4.7ZM218.8,24.7c.8-.8,1.1-1.8,1.1-3.1s-.4-2.3-1.1-3.1-1.8-1.2-2.9-1.2-2.2.4-2.9,1.2c-.8.8-1.1,1.9-1.1,3.1s.4,2.3,1.1,3.1,1.7,1.2,2.9,1.2,2.2-.4,2.9-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.1,14.7c1.3,1.4,1.9,3.3,1.9,5.8v9.7h-5.4v-9.4c0-1.1-.3-2-.8-2.6s-1.3-.9-2.3-.9-1.9.4-2.6,1.1c-.6.7-1,1.6-1,2.8v9h-5.4V13h4.7l.4,2c.7-.8,1.5-1.4,2.4-1.8s2-.6,3.1-.6c2.1,0,3.8.7,5.1,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.9,5.9v24.3h-4.7l-.4-2c-1.5,1.6-3.4,2.4-5.7,2.4s-3-.4-4.2-1.1-2.2-1.8-2.9-3.2c-.7-1.4-1-2.9-1-4.6s.4-3.3,1-4.6c.7-1.4,1.7-2.4,2.9-3.2,1.2-.8,2.6-1.1,4.2-1.1s3.9.7,5.3,2V5.9h5.5ZM262.3,24.7c.8-.8,1.1-1.8,1.1-3.1s-.4-2.3-1.1-3.1-1.8-1.2-3-1.2-2.2.4-2.9,1.2c-.8.8-1.1,1.9-1.1,3.1s.4,2.3,1.1,3.1,1.7,1.2,2.9,1.2,2.2-.4,3-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.9,71.8l-1.8-4.4h-12l-1.8,4.4h-6.1l10.9-24.3h6.1l10.8,24.3h-6.1ZM198.2,52.9l-4,9.6h7.9l-3.9-9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.9,71.1c-1.4-.7-2.5-1.8-3.3-3.1-.8-1.3-1.2-2.9-1.2-4.7s.4-3.3,1.2-4.7c.8-1.3,1.9-2.4,3.3-3.2,1.4-.8,3-1.1,4.9-1.1s2.5.2,3.6.7,2.2,1.1,3.1,2l-3,3.3c-1-.9-2.1-1.3-3.4-1.3s-2.3.4-3.1,1.2c-.8.8-1.2,1.8-1.2,3.1s.4,2.3,1.2,3.1,1.8,1.2,3.1,1.2,2.6-.5,3.6-1.5l3.1,3.3c-1.9,1.9-4.2,2.8-6.9,2.8s-3.6-.4-5-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.8,54.6v24.5h-5.4v-9.1c-1.4,1.3-3.2,2-5.3,2s-3-.4-4.3-1.1-2.2-1.8-2.9-3.2-1-2.9-1-4.6.4-3.3,1-4.6c.7-1.3,1.7-2.4,2.9-3.2,1.2-.8,2.7-1.1,4.3-1.1,2.4,0,4.2.8,5.7,2.4l.4-2h4.7,0ZM242.3,66.3c.8-.8,1.1-1.8,1.1-3.1s-.4-2.3-1.1-3.1-1.7-1.2-2.9-1.2-2.2.4-2.9,1.2c-.8.8-1.1,1.8-1.1,3.1s.4,2.3,1.1,3.1,1.8,1.2,2.9,1.2,2.2-.4,2.9-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.2,54.6v17.1h-4.7l-.4-2c-.6.8-1.4,1.3-2.4,1.8s-2,.6-3.1.6c-2.1,0-3.8-.7-5-2.1s-1.9-3.3-1.9-5.8v-9.7h5.5v9.4c0,1.1.3,2,.8,2.6.5.6,1.3.9,2.2.9s1.9-.4,2.5-1.1c.6-.7,1-1.7,1-2.8v-9h5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.7,52.1c-.6-.5-.9-1.3-.9-2.1s.3-1.6.9-2.2c.6-.6,1.4-.8,2.3-.8s1.7.3,2.3.8c.6.5.9,1.3.9,2.2s-.3,1.6-.9,2.1-1.4.8-2.3.8-1.7-.3-2.3-.8ZM274.3,54.6h5.4v17.1h-5.4v-17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.5,69.9l2.1-3.8c.8.5,1.8.9,2.9,1.2s2.2.4,3.3.4,2.2-.4,2.2-1.2-.2-.7-.6-.9c-.4-.2-1.1-.3-2.1-.4-2.2-.1-3.9-.7-5.2-1.6s-1.9-2.2-1.9-3.8.7-3.1,2.1-4.1c1.4-1,3.3-1.5,5.6-1.5s2.6.2,3.8.5c1.2.3,2.3.8,3.1,1.3l-2.1,3.6c-1.3-.7-2.8-1.1-4.6-1.1s-2.6.4-2.6,1.2.2.6.5.8c.4.2,1,.3,1.8.4,2.5.2,4.3.7,5.6,1.7,1.3.9,1.9,2.2,1.9,3.9s-.7,3.1-2.1,4.1c-1.4,1-3.4,1.5-5.9,1.5s-5.7-.8-7.9-2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.8,52.1c-.6-.5-.9-1.3-.9-2.1s.3-1.6.9-2.2c.6-.6,1.4-.8,2.3-.8s1.7.3,2.3.8c.6.5.9,1.3.9,2.2s-.3,1.6-.9,2.1-1.4.8-2.3.8-1.7-.3-2.3-.8ZM301.4,54.6h5.4v17.1h-5.4v-17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.2,71.1c-1.3.7-2.9,1-4.5,1s-3.4-.5-4.4-1.6-1.6-2.8-1.6-5.1v-6.5h-2.9v-4.3h2.9v-4.3l5.4-.6v4.9h4.3v4.3h-4.3v6.5c0,.7.2,1.2.5,1.5s.8.5,1.4.5,1.3-.2,2-.5l1.3,4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326,52.1c-.6-.5-.9-1.3-.9-2.1s.3-1.6.9-2.2c.6-.6,1.4-.8,2.3-.8s1.7.3,2.3.8c.6.5.9,1.3.9,2.2s-.3,1.6-.9,2.1-1.4.8-2.3.8-1.7-.3-2.3-.8ZM325.6,54.6h5.5v17.1h-5.5v-17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.6,71c-1.4-.8-2.5-1.8-3.3-3.1-.8-1.3-1.1-2.9-1.1-4.7s.4-3.3,1.1-4.7c.8-1.3,1.9-2.4,3.3-3.1s3.1-1.1,5-1.1,3.6.4,5,1.1,2.5,1.8,3.3,3.1,1.1,2.9,1.1,4.7-.4,3.3-1.1,4.7c-.8,1.3-1.9,2.4-3.3,3.1-1.4.8-3.1,1.1-5,1.1s-3.6-.4-5-1.1ZM346.5,66.3c.7-.8,1.1-1.8,1.1-3.1s-.4-2.3-1.1-3.1c-.7-.8-1.7-1.2-2.9-1.2s-2.1.4-2.9,1.2-1.1,1.8-1.1,3.1.4,2.3,1.1,3.1,1.7,1.2,2.9,1.2,2.2-.4,2.9-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.8,56.3c1.3,1.4,1.9,3.3,1.9,5.8v9.7h-5.4v-9.4c0-1.1-.3-2-.8-2.6s-1.3-.9-2.3-.9-1.9.4-2.6,1.1c-.6.7-1,1.7-1,2.8v9h-5.5v-17.1h4.7l.4,2c.7-.8,1.5-1.3,2.4-1.8.9-.4,2-.6,3.1-.6,2.1,0,3.8.7,5.1,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.8,89.1h5.1v24.3h-5.6v-15.2l-7.1,8.7h-1.1l-7.2-8.8v15.2h-5.6v-24.3h5.1l8.3,10.3,8.3-10.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.1,96.2v17.1h-4.7l-.4-2.1c-1.5,1.6-3.4,2.4-5.7,2.4s-3-.4-4.2-1.1-2.2-1.8-2.9-3.2c-.7-1.3-1-2.9-1-4.6s.4-3.3,1-4.6c.7-1.3,1.7-2.4,2.9-3.2,1.2-.8,2.6-1.1,4.2-1.1s2.2.2,3.2.6c1,.4,1.8,1,2.5,1.8l.4-2h4.7ZM229.6,107.9c.8-.8,1.1-1.8,1.1-3.1s-.4-2.3-1.1-3.1-1.8-1.2-2.9-1.2-2.2.4-2.9,1.2c-.8.8-1.1,1.8-1.1,3.1s.4,2.3,1.1,3.1c.8.8,1.7,1.2,2.9,1.2s2.2-.4,2.9-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.9,97.9c1.3,1.4,1.9,3.3,1.9,5.8v9.7h-5.4v-9.4c0-1.1-.3-2-.8-2.6s-1.3-.9-2.3-.9-1.9.4-2.6,1.1-1,1.7-1,2.8v9h-5.4v-17.1h4.7l.4,2c.7-.8,1.5-1.3,2.4-1.8s2-.6,3.1-.6c2.1,0,3.8.7,5.1,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.6,96.2v17.1h-4.7l-.4-2.1c-1.5,1.6-3.4,2.4-5.7,2.4s-3-.4-4.2-1.1-2.2-1.8-2.9-3.2c-.7-1.3-1-2.9-1-4.6s.4-3.3,1-4.6,1.7-2.4,2.9-3.2,2.6-1.1,4.2-1.1,2.2.2,3.2.6c1,.4,1.8,1,2.5,1.8l.4-2h4.7ZM273.1,107.9c.8-.8,1.1-1.8,1.1-3.1s-.4-2.3-1.1-3.1-1.8-1.2-3-1.2-2.2.4-2.9,1.2c-.8.8-1.1,1.8-1.1,3.1s.4,2.3,1.1,3.1c.8.8,1.7,1.2,2.9,1.2s2.2-.4,3-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.7,112.8c.6.9,1,2,1,3.2s-.4,2.7-1.2,3.8c-.8,1.1-1.9,1.9-3.3,2.5s-3.1.9-5,.9-3.5-.3-4.9-.9c-1.4-.6-2.5-1.5-3.2-2.6s-1.1-2.4-1.1-3.8,0-.7,0-.8h5.2c0,1.1.3,2,1,2.6.7.6,1.7.9,3,.9s2.1-.3,2.8-.8,1.1-1.2,1.1-2.1-.3-1.6-1-2-1.6-.7-2.8-.7c-1.9,0-3.6-.4-5-1.1s-2.5-1.7-3.3-3c-.8-1.3-1.2-2.8-1.2-4.6s.4-3.2,1.2-4.5c.8-1.3,1.9-2.3,3.3-3.1,1.4-.7,3-1.1,4.9-1.1s2.7.3,3.9.8l2-2.5,4,2.9-2.3,2.7c1.2,1.3,1.7,2.9,1.7,4.7s-.3,2.4-.9,3.5c-.6,1.1-1.5,2-2.6,2.7,1.2.5,2,1.3,2.7,2.2h0ZM295.1,107.3c.7-.7,1.1-1.7,1.1-2.9s-.4-2.2-1.1-2.9-1.7-1.1-2.9-1.1-2.2.4-2.9,1.1c-.7.7-1.1,1.7-1.1,2.9s.4,2.2,1.1,2.9,1.7,1.1,2.9,1.1,2.2-.4,2.9-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M318.1,96.9c1.4.7,2.4,1.7,3.1,3,.7,1.3,1.1,2.8,1.1,4.5s0,1.2-.2,2.1h-12.6c.2.9.6,1.6,1.4,2.1.8.5,1.8.8,3,.8s1.7-.1,2.5-.4,1.5-.6,2.1-1.1l2.8,3.1c-1,.9-2.1,1.6-3.5,2.1-1.3.5-2.8.7-4.2.7s-3.7-.4-5.2-1.1c-1.5-.7-2.6-1.8-3.4-3.1s-1.2-2.9-1.2-4.8.4-3.3,1.2-4.7,1.9-2.4,3.2-3.2c1.4-.8,3-1.1,4.8-1.1s3.5.3,4.9,1.1h0ZM310.8,101c-.7.6-1.1,1.3-1.2,2.3h7.6c0-1-.4-1.8-1.1-2.3s-1.5-.8-2.6-.8-2,.3-2.6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351.4,97.8c1.2,1.3,1.9,3,1.9,5.2v10.4h-5.4v-9.7c0-1-.2-1.8-.7-2.4s-1.1-.8-2-.8-1.7.3-2.2,1c-.6.7-.8,1.5-.8,2.6v9.4h-5.4v-9.7c0-1-.2-1.8-.7-2.4s-1.1-.8-2-.8-1.7.3-2.3,1c-.6.7-.9,1.5-.9,2.6v9.4h-5.5v-17.1h4.7l.3,1.9c.6-.7,1.3-1.3,2.2-1.7.8-.4,1.8-.6,2.7-.6s2.1.2,3,.7,1.6,1.1,2.1,2c1.4-1.8,3.4-2.7,5.9-2.7s3.9.6,5.1,1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.3,96.9c1.4.7,2.4,1.7,3.1,3,.7,1.3,1.1,2.8,1.1,4.5s0,1.2-.2,2.1h-12.6c.2.9.6,1.6,1.4,2.1.8.5,1.8.8,3,.8s1.7-.1,2.5-.4,1.5-.6,2.1-1.1l2.8,3.1c-1,.9-2.1,1.6-3.5,2.1-1.3.5-2.8.7-4.2.7s-3.7-.4-5.2-1.1c-1.5-.7-2.6-1.8-3.4-3.1s-1.2-2.9-1.2-4.8.4-3.3,1.2-4.7,1.9-2.4,3.2-3.2c1.4-.8,3-1.1,4.8-1.1s3.5.3,4.9,1.1h0ZM362.9,101c-.7.6-1.1,1.3-1.2,2.3h7.6c0-1-.4-1.8-1.1-2.3s-1.5-.8-2.6-.8-2,.3-2.6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M393.2,97.9c1.3,1.4,1.9,3.3,1.9,5.8v9.7h-5.4v-9.4c0-1.1-.3-2-.8-2.6s-1.3-.9-2.3-.9-1.9.4-2.6,1.1-1,1.7-1,2.8v9h-5.5v-17.1h4.7l.4,2c.7-.8,1.5-1.3,2.4-1.8s2-.6,3.1-.6c2.1,0,3.8.7,5.1,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M411.1,112.7c-1.3.7-2.9,1-4.5,1s-3.4-.5-4.4-1.6-1.6-2.8-1.6-5.1v-6.5h-2.9v-4.3h2.9v-4.3l5.4-.6v4.9h4.3v4.3h-4.3v6.5c0,.7.2,1.2.5,1.5.4.3.8.5,1.4.5s1.3-.2,2-.5l1.3,4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.4,154.6c-1.8-.6-3.4-1.4-4.8-2.5l2.9-4.1c2.1,1.7,4.7,2.5,7.5,2.5s2.6-.2,3.4-.7c.8-.5,1.3-1.1,1.3-2s-.4-1.4-1.2-1.8-2-.8-3.8-.9c-3.3-.4-5.7-1.1-7.3-2.3-1.5-1.2-2.3-2.9-2.3-5.1s.4-2.8,1.2-3.9,2-2,3.5-2.6c1.5-.6,3.2-.9,5.2-.9s3.3.2,4.9.7c1.6.5,3,1.2,4.2,2.1l-2.7,4c-1.9-1.3-4-2-6.3-2s-2.5.2-3.4.7c-.8.5-1.3,1.1-1.3,1.9s.4,1.4,1.1,1.8,1.9.7,3.7.9c3.3.4,5.7,1.2,7.4,2.4s2.4,3,2.4,5.2-.4,2.9-1.3,4-2.1,2.1-3.6,2.7c-1.6.6-3.3.9-5.3.9s-3.9-.3-5.7-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.6,137.9h5.9l-10.7,24.6h-5.8l3.3-7.7-6.7-16.9h5.9l2,5.4,1.9,5.6,2-5.6,2.2-5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.9,153.1l2.1-3.8c.8.5,1.8.9,2.9,1.2,1.1.3,2.2.4,3.3.4s2.2-.4,2.2-1.2-.2-.7-.6-.9c-.4-.2-1.1-.4-2.1-.4-2.2-.1-3.9-.7-5.2-1.6s-1.9-2.2-1.9-3.8.7-3.1,2.1-4.1,3.3-1.5,5.6-1.5,2.6.2,3.8.5c1.2.3,2.3.8,3.1,1.4l-2.1,3.6c-1.3-.7-2.8-1.1-4.6-1.1s-2.6.4-2.6,1.2.2.6.5.8c.4.2,1,.3,1.8.4,2.4.2,4.3.7,5.6,1.7s1.9,2.2,1.9,3.9-.7,3.1-2.1,4.1c-1.4,1-3.4,1.5-5.9,1.5s-5.7-.8-7.9-2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M258,154.3c-1.3.7-2.9,1-4.5,1s-3.4-.5-4.4-1.6-1.6-2.8-1.6-5.1v-6.5h-2.9v-4.3h2.9v-4.3l5.4-.6v4.9h4.3v4.3h-4.3v6.5c0,.7.2,1.2.5,1.5.4.3.8.5,1.4.5s1.3-.2,2-.5l1.3,4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.4,138.5c1.4.7,2.4,1.7,3.1,3s1.1,2.8,1.1,4.5,0,1.2-.2,2.1h-12.6c.2.9.6,1.6,1.4,2.1.8.5,1.8.8,3,.8s1.7-.1,2.5-.4,1.5-.6,2.1-1.1l2.8,3.1c-1,.9-2.1,1.6-3.5,2.1-1.3.5-2.8.7-4.2.7s-3.7-.4-5.2-1.1c-1.5-.7-2.6-1.8-3.4-3.1s-1.2-2.9-1.2-4.8.4-3.3,1.2-4.7c.8-1.4,1.9-2.4,3.2-3.2,1.4-.8,3-1.1,4.8-1.1s3.5.4,4.9,1.1h0ZM266.1,142.6c-.7.6-1.1,1.3-1.2,2.3h7.6c0-1-.4-1.8-1.1-2.3s-1.5-.8-2.6-.8-2,.3-2.6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M306.7,139.4c1.2,1.3,1.9,3,1.9,5.2v10.4h-5.4v-9.7c0-1-.2-1.8-.7-2.4s-1.1-.9-2-.9-1.7.3-2.2,1c-.6.6-.8,1.5-.8,2.6v9.4h-5.4v-9.7c0-1-.2-1.8-.7-2.4s-1.1-.9-2-.9-1.7.3-2.3,1c-.6.6-.9,1.5-.9,2.6v9.4h-5.5v-17.1h4.7l.3,1.9c.6-.7,1.3-1.3,2.2-1.7.8-.4,1.8-.6,2.7-.6s2.1.2,3,.7,1.6,1.1,2.1,2c1.4-1.8,3.4-2.7,5.9-2.7s3.9.6,5.1,1.9h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 85.1,
    cy: 47.4,
    r: 17.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconDark);
export default __webpack_public_path__ + "static/media/logo-icon-dark.8a33155f7e56be0244632b0005faf7ad.svg";
export { ForwardRef as ReactComponent };